/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';

interface IClientComponentProps {
  children?: React.ReactNode;
  replaceNode?: React.ReactNode;
}

export function ClientComponent({ replaceNode, children }: IClientComponentProps) {
  const isBrowserBuild = Boolean(process.env.IS_BROWSER_BUILD);
  const [showChild, setShowChild] = React.useState(false);

  /**
   * Фикс бага, из-за которого содержимое ClientComponent рендерится
   * не в родителе, а в его соседнем компоненте. При этом в виртуальном DOM
   * компоненты расположены правильно, а их ноды в реальном DOM нет. Я не смог
   * найти прямого виновника такого поведения.
   *
   * Здесь вызывается дополнительный ререндер компонента на клиенте,
   * что "вправляет" его отображение в DOM.
   * Вторым решением будет возвращать не фрагмент, а <div /> обертку. Но
   * тогда в HTML местами будут находиться пустые <div /> от ClientComponent.
   */
  React.useEffect(() => setShowChild(true), []);

  return <>{isBrowserBuild && showChild ? children : replaceNode}</>;
}
